export default __webpack_public_path__ + "static/media/p18.1869c8e7.jpg";